export default "__VITE_ASSET__c5b06d84__"